import type { IntlShape } from 'react-intl';

import { FieldData } from './types';

export const validateFieldData = (
  fieldData: FieldData,
  intl: IntlShape,
): string | undefined => {
  const { fieldName, fieldSectionId, fieldType } = fieldData;
  if (!fieldName) {
    return intl.formatMessage({
      id: 'Utils.fieldNameRequired',
      defaultMessage: 'Field name is required.',
      description: 'Validation error when field name is missing',
    });
  }
  if (!fieldSectionId) {
    return intl.formatMessage({
      id: 'Utils.fieldSectionRequired',
      defaultMessage: 'Field section is required.',
      description: 'Validation error when field section is missing',
    });
  }
  if (!fieldType) {
    return intl.formatMessage({
      id: 'Utils.fieldTypeRequired',
      defaultMessage: 'Field type is required.',
      description: 'Validation error when field type is missing',
    });
  }
};

export const testEnableSort = (
  optionsConfig: FieldData['fieldConfig']['optionsConfig'],
): boolean => {
  return optionsConfig.includes('enable_sort');
};
